import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalSearch } from '@/api/base';
import { useDismiss } from '@/components/kit/useDismiss';
import { formatPhone } from '@/lib/phone';
import { rolesLine } from './labels';

/**
 * Общий поиск по базе — поле в боковом меню (БЛ 5.14, ТЗ M2 5.3):
 * клиенты, студии и команды группами, от двух символов.
 */
export function GlobalSearch() {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const wrap = useRef<HTMLDivElement>(null);
  const close = useCallback(() => setOpen(false), []);
  useDismiss(open, close, wrap);

  useEffect(() => {
    const t = window.setTimeout(() => setQ(text.trim()), 250);
    return () => window.clearTimeout(t);
  }, [text]);

  const result = useGlobalSearch(q);
  const r = result.data;
  const go = (to: string) => {
    setText('');
    setOpen(false);
    navigate(to);
  };
  const empty = r && !r.clients.length && !r.studios.length && !r.teams.length;

  return (
    <div className="gsw" ref={wrap}>
      <input
        className="inp"
        placeholder="Поиск: ФИО, телефон, почта, название"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
      />
      {open && q.length >= 2 && r ? (
        <div className="pop gpop">
          {r.clients.length ? <div className="mg">Клиенты</div> : null}
          {r.clients.map((c) => (
            <div className="op" key={c.id} onClick={() => go(`/clients/${c.id}`)}>
              <span className="gt">
                <span>{c.fullName}</span>
                <span className="gd">
                  {[formatPhone(c.phone), c.email, rolesLine(c.roles, c.studioRoles).toLowerCase()].filter(Boolean).join(' · ')}
                </span>
              </span>
            </div>
          ))}
          {r.studios.length ? <div className="mg">Студии</div> : null}
          {r.studios.map((s) => (
            <div className="op" key={s.id} onClick={() => go(`/studios/${s.id}`)}>
              <span className="gt">
                <span>{s.name}</span>
                <span className="gd">{s.city}</span>
              </span>
            </div>
          ))}
          {r.teams.length ? <div className="mg">Команды</div> : null}
          {r.teams.map((t) => (
            <div className="op" key={t.id} onClick={() => go(`/teams/${t.id}`)}>
              <span className="gt">
                <span>{t.name}</span>
                <span className="gd">
                  {t.city} · {t.head}
                </span>
              </span>
            </div>
          ))}
          {empty ? <div className="op dim">Ничего не нашли</div> : null}
        </div>
      ) : null}
    </div>
  );
}
